/* Coconut product page: gallery, size buttons, bundles, add to cart (theme cart drawer),
   sticky bar with size sheet, review quotes, scrollers and recipe links.
   Loaded only by the nune-coco-* sections. */
(function () {
  'use strict';
  if (window.ncoLoaded) return;
  window.ncoLoaded = true;

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    var fmt = format || '{{amount}}';
    function withDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(number) || number == null) return '0';
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : '';
      return dollars + centsPart;
    }
    var m = fmt.match(placeholder);
    switch (m ? m[1] : 'amount') {
      case 'amount_no_decimals': value = withDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
      default: value = withDelimiters(cents, 2);
    }
    return fmt.replace(placeholder, value);
  }

  // Litres in a variant title such as "1 Litre ( Glass Bottle )", "5 Litre Tin" or "500ml".
  function litresIn(title) {
    var m = String(title).match(/(\d+(?:\.\d+)?)\s*(ml|millilitre|milliliter|l|ltr|litre|liter|lt)\b/i);
    if (!m) return null;
    var n = parseFloat(m[1]);
    return /^m/i.test(m[2]) ? n / 1000 : n;
  }

  // "1 Litre ( Glass Bottle )" -> "1 Litre (Glass Bottle)" for display only
  function tidy(s) { return String(s).replace(/\(\s+/g, '(').replace(/\s+\)/g, ')'); }

  // Price per litre in whole rupees, e.g. "Rs. 380"
  function perLitreText(cents, format) {
    return formatMoney(Math.round(cents / 100) * 100, format).replace(/[.,]00(?!\d)/, '');
  }

  function addToCart(variantId, quantity, button, root) {
    var cart = document.querySelector('cart-drawer');
    var fd = new FormData();
    fd.append('id', variantId);
    fd.append('quantity', quantity || 1);
    if (cart && typeof cart.getSectionsToRender === 'function') {
      fd.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }));
      fd.append('sections_url', window.location.pathname);
    }
    var base = (window.routes && window.routes.cart_add_url) || '/cart/add';
    if (button) { button.setAttribute('aria-busy', 'true'); button.disabled = true; }
    return fetch(base.replace(/\.js$/, '') + '.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
      body: fd
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) {
          showMessage(root, res.description || res.message || 'Could not add to cart. Please try again.', true);
          return;
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'nco-product', productVariantId: variantId, cartData: res });
        }
        if (cart && cart.dataset.cartType === 'drawer' && typeof cart.renderContents === 'function' && res.sections) {
          cart.classList.remove('is-empty');
          cart.renderContents(res, !document.body.classList.contains('page-overlay-cart-on'));
        } else if (cart && cart.dataset.cartType !== 'drawer') {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        } else {
          showMessage(root, 'Added to cart.', false);
        }
      })
      .catch(function () { showMessage(root, 'Could not add to cart. Check your connection and try again.', true); })
      .finally(function () {
        if (button) { button.removeAttribute('aria-busy'); button.disabled = button.hasAttribute('data-soldout-lock'); }
      });
  }

  function showMessage(root, text, isError) {
    var toast = root && root.querySelector('[data-toast]');
    if (!toast) { if (isError) window.alert(text); return; }
    toast.textContent = text;
    toast.classList.toggle('is-error', !!isError);
    toast.hidden = false;
    clearTimeout(toast._t);
    toast._t = setTimeout(function () { toast.hidden = true; }, 4000);
  }

  function initProduct(root) {
    if (root.__init) return; root.__init = true;
    var dataEl = root.querySelector('[data-variants]');
    var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
    var money = root.getAttribute('data-money-format') || '{{amount}}';
    var input = root.querySelector('[data-variant-input]');
    var current = variants.find(function (v) { return input && String(v.id) === input.value; }) || variants[0];
    var qtyInput = root.querySelector('[data-qty]');

    // ---------- price per litre, best value tag ----------
    var perL = {};
    variants.forEach(function (v) { var l = litresIn(v.title); if (l) perL[v.id] = v.price / l; });
    var ids = variants.filter(function (v) { return v.available && perL[v.id]; }).map(function (v) { return String(v.id); });
    var bestId = null;
    if (ids.length > 1) {
      ids.sort(function (a, b) { return perL[a] - perL[b]; });
      if (perL[ids[0]] <= perL[ids[1]] * 0.99) bestId = ids[0];
    }
    var singleOption = root.querySelectorAll('.nco-variants [data-option-index]').length === 1;
    if (singleOption) {
      root.querySelectorAll('.nco-variants [data-option-value]').forEach(function (btn) {
        var v = variants.find(function (x) { return x.option1 === btn.getAttribute('data-option-value'); });
        if (!v) return;
        var sub = btn.querySelector('[data-pill-sub]');
        if (sub && perL[v.id]) sub.textContent = perLitreText(perL[v.id], money) + '/L';
        var tag = btn.querySelector('[data-pill-tag]');
        if (tag && String(v.id) === String(bestId)) { tag.textContent = 'Best price per litre'; tag.hidden = false; }
      });
    }
    root.querySelectorAll('[data-sheet-variant]').forEach(function (row) {
      var id = row.getAttribute('data-sheet-variant');
      var sub = row.querySelector('[data-sheet-sub]');
      if (sub && perL[id]) sub.textContent = perLitreText(perL[id], money) + ' per litre' + (String(id) === String(bestId) ? ' · best price' : '');
    });

    // ---------- variant selection ----------
    function selectedOptions() {
      var group = root.querySelector('.nco-variants') || root.querySelector('.nco-sticky__variants');
      if (!group) return current ? current.options.slice() : [];
      return Array.prototype.map.call(group.querySelectorAll('[data-option-index]'), function (fs) {
        var on = fs.querySelector('[aria-pressed="true"]');
        return on ? on.getAttribute('data-option-value') : null;
      });
    }

    function render(v, initial) {
      if (!v) return;
      current = v;
      if (input) input.value = v.id;
      var priceText = formatMoney(v.price, money);
      root.querySelectorAll('[data-price]').forEach(function (el) { el.textContent = priceText; });
      root.querySelectorAll('[data-compare]').forEach(function (el) {
        var show = v.compare_at_price && v.compare_at_price > v.price;
        el.hidden = !show;
        if (show) el.textContent = formatMoney(v.compare_at_price, money);
      });
      root.querySelectorAll('[data-size-label]').forEach(function (el) { el.textContent = tidy(v.title); });
      root.querySelectorAll('[data-unit-price]').forEach(function (el) {
        el.textContent = perL[v.id] && litresIn(v.title) !== 1 ? '(' + perLitreText(perL[v.id], money) + '/L)' : '';
      });
      root.querySelectorAll('[data-atc], [data-sticky-atc], [data-sheet-atc]').forEach(function (btn) {
        var label = btn.getAttribute('data-label') || 'Add to cart';
        var span = btn.querySelector('[data-atc-label]');
        if (v.available) { btn.removeAttribute('data-soldout-lock'); btn.disabled = false; if (span) span.textContent = label + ' — ' + priceText; }
        else { btn.setAttribute('data-soldout-lock', ''); btn.disabled = true; if (span) span.textContent = 'Sold out'; }
      });
      var stock = root.querySelector('[data-stock]');
      if (stock) {
        stock.classList.toggle('is-out', !v.available);
        var lbl = stock.querySelector('[data-stock-label]');
        if (lbl) lbl.textContent = v.available ? stock.getAttribute('data-in') : stock.getAttribute('data-out');
      }
      // buttons in every picker (main, sticky)
      root.querySelectorAll('[data-option-index]').forEach(function (group) {
        var idx = parseInt(group.getAttribute('data-option-index'), 10);
        group.querySelectorAll('[data-option-value]').forEach(function (b) {
          b.setAttribute('aria-pressed', b.getAttribute('data-option-value') === v.options[idx] ? 'true' : 'false');
          // grey out values that are sold out given the other selected options
          var probe = v.options.slice(); probe[idx] = b.getAttribute('data-option-value');
          var match = variants.find(function (x) { return x.options.join('|') === probe.join('|'); });
          b.classList.toggle('is-soldout', !match || !match.available);
        });
        var legend = group.querySelector('[data-option-selected]');
        if (legend) legend.textContent = tidy(v.options[idx]);
      });
      root.querySelectorAll('[data-sheet-variant]').forEach(function (row) {
        row.setAttribute('aria-pressed', String(row.getAttribute('data-sheet-variant')) === String(v.id) ? 'true' : 'false');
      });
      if (initial) return;
      // URL and gallery
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      } catch (e) { /* ignore */ }
      if (v.featured_media && gallery) gallery.goToMedia(v.featured_media.id);
    }

    root.addEventListener('click', function (e) {
      var opt = e.target.closest('[data-option-value]');
      if (opt && root.contains(opt)) {
        var group = opt.closest('[data-option-index]');
        var idx = parseInt(group.getAttribute('data-option-index'), 10);
        var opts = current ? current.options.slice() : selectedOptions();
        opts[idx] = opt.getAttribute('data-option-value');
        var v = variants.find(function (x) { return x.options.join('|') === opts.join('|'); }) ||
                variants.find(function (x) { return x.options[idx] === opts[idx]; });
        render(v);
        return;
      }
      var row = e.target.closest('[data-sheet-variant]');
      if (row) {
        render(variants.find(function (x) { return String(x.id) === row.getAttribute('data-sheet-variant'); }));
        return;
      }
      var bundle = e.target.closest('[data-bundle-qty]');
      if (bundle) {
        var q = parseInt(bundle.getAttribute('data-bundle-qty'), 10) || 1;
        var already = bundle.getAttribute('aria-pressed') === 'true';
        root.querySelectorAll('[data-bundle-qty]').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
        if (!already) bundle.setAttribute('aria-pressed', 'true');
        if (qtyInput) qtyInput.value = already ? 1 : q;
        return;
      }
      if (e.target.closest('[data-qty-minus]') && qtyInput) { qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1); syncBundles(); return; }
      if (e.target.closest('[data-qty-plus]') && qtyInput) { qtyInput.value = Math.min(99, (parseInt(qtyInput.value, 10) || 1) + 1); syncBundles(); return; }
      var stickyAtc = e.target.closest('[data-sticky-atc], [data-sheet-atc]');
      if (stickyAtc && current) {
        addToCart(current.id, qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1, stickyAtc, root).then(closeSheet);
        return;
      }
      if (e.target.closest('[data-sheet-open]')) { openSheet(); return; }
      if (e.target.closest('[data-sheet-close]')) { closeSheet(); return; }
      var fbt = e.target.closest('[data-fbt-add]');
      if (fbt) { addToCart(fbt.getAttribute('data-fbt-add'), 1, fbt, root); return; }
    });

    function syncBundles() {
      var q = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
      root.querySelectorAll('[data-bundle-qty]').forEach(function (b) {
        b.setAttribute('aria-pressed', parseInt(b.getAttribute('data-bundle-qty'), 10) === q ? 'true' : 'false');
      });
    }
    if (qtyInput) qtyInput.addEventListener('change', function () {
      qtyInput.value = Math.min(99, Math.max(1, parseInt(qtyInput.value, 10) || 1)); syncBundles();
    });

    var form = root.querySelector('[data-nco-form]');
    if (form) form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!current) return;
      addToCart(current.id, qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1, form.querySelector('[data-atc]'), root);
    });

    // ---------- size sheet (phones) ----------
    var sheet = root.querySelector('[data-sheet]');
    function openSheet() { if (!sheet) return; sheet.hidden = false; document.documentElement.classList.add('nco-lock'); var f = sheet.querySelector('[aria-pressed="true"]') || sheet.querySelector('button'); if (f) f.focus(); }
    function closeSheet() { if (!sheet || sheet.hidden) return; sheet.hidden = true; document.documentElement.classList.remove('nco-lock'); }
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeSheet(); });

    // ---------- sticky bar ----------
    var bar = root.querySelector('[data-sticky-bar]');
    var mainAtc = root.querySelector('[data-atc]');
    var mode = root.getAttribute('data-sticky');
    var barShown = null;
    function setBar(show) {
      if (!bar || show === barShown) return;
      barShown = show;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      document.body.style.paddingBottom = show ? bar.offsetHeight + 'px' : '';
    }
    if (bar) {
      if (mode === 'always' || !mainAtc) {
        setBar(true);
      } else {
        // Show once the main button has scrolled above the screen. A scroll check (not IntersectionObserver)
        // also catches jumps past the button, e.g. from a recipe link.
        var ticking = false;
        var update = function () { ticking = false; setBar(mainAtc.getBoundingClientRect().bottom < 0); };
        var onScroll = function () { if (!ticking) { ticking = true; window.requestAnimationFrame(update); } };
        window.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', onScroll);
        update();
      }
    }

    // ---------- gallery ----------
    var gallery = null;
    var track = root.querySelector('[data-gal-track]');
    if (track) {
      var slides = Array.prototype.slice.call(track.querySelectorAll('[data-index]'));
      var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-gal-thumb]'));
      var dots = Array.prototype.slice.call(root.querySelectorAll('[data-gal-dot]'));
      var active = 0;
      var goTo = function (i) {
        if (!slides.length) return;
        i = (i + slides.length) % slides.length;
        track.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' });
        mark(i);
      };
      var mark = function (i) {
        active = i;
        thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === i); });
        dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
        var t = thumbs[i];
        if (t && t.parentElement) t.parentElement.scrollTo({ left: t.offsetLeft - t.parentElement.clientWidth / 2 + t.clientWidth / 2, behavior: 'smooth' });
      };
      var scrollTimer;
      track.addEventListener('scroll', function () {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(function () {
          var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
          if (i !== active) mark(Math.min(slides.length - 1, Math.max(0, i)));
        }, 80);
      }, { passive: true });
      var prev = root.querySelector('[data-gal-prev]');
      var next = root.querySelector('[data-gal-next]');
      if (prev) prev.addEventListener('click', function () { goTo(active - 1); });
      if (next) next.addEventListener('click', function () { goTo(active + 1); });
      thumbs.forEach(function (t) { t.addEventListener('click', function () { goTo(parseInt(t.getAttribute('data-gal-thumb'), 10)); }); });
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); goTo(active + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(active - 1); }
      });
      gallery = {
        goToMedia: function (mediaId) {
          var s = slides.find(function (el) { return el.getAttribute('data-media-id') === String(mediaId); });
          if (s) goTo(parseInt(s.getAttribute('data-index'), 10));
        }
      };
    }

    // ---------- review quotes ----------
    var quotes = Array.prototype.slice.call(root.querySelectorAll('[data-quote]'));
    if (quotes.length) {
      var qi = 0;
      var showQuote = function (i) { qi = (i + quotes.length) % quotes.length; quotes.forEach(function (q, n) { q.hidden = n !== qi; }); };
      var qp = root.querySelector('[data-quote-prev]'); var qn = root.querySelector('[data-quote-next]');
      if (quotes.length < 2) { if (qp) qp.hidden = true; if (qn) qn.hidden = true; }
      if (qp) qp.addEventListener('click', function () { showQuote(qi - 1); });
      if (qn) qn.addEventListener('click', function () { showQuote(qi + 1); });
    }

    // ---------- bought together scroller ----------
    var ft = root.querySelector('[data-fbt-track]');
    if (ft) {
      var fp = root.querySelector('[data-fbt-prev]'); var fn = root.querySelector('[data-fbt-next]');
      if (fp) fp.addEventListener('click', function () { ft.scrollBy({ left: -ft.clientWidth * 0.8, behavior: 'smooth' }); });
      if (fn) fn.addEventListener('click', function () { ft.scrollBy({ left: ft.clientWidth * 0.8, behavior: 'smooth' }); });
    }

    render(current, true);
  }

  // ---------- horizontal scrollers in other sections (origin stories) ----------
  function initScroller(el) {
    if (el.__init) return; el.__init = true;
    var track = el.querySelector('[data-scroll-track]');
    if (!track) return;
    var step = function (dir) { track.scrollBy({ left: dir * Math.max(240, track.clientWidth * 0.8), behavior: 'smooth' }); };
    var p = el.querySelector('[data-scroll-prev]'); var n = el.querySelector('[data-scroll-next]');
    if (p) p.addEventListener('click', function () { step(-1); });
    if (n) n.addEventListener('click', function () { step(1); });
  }

  // ---------- hero "Shop" buttons scroll to the sizes and Add to cart ----------
  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('[data-nco-buy]');
    if (!link) return;
    var pdp = document.querySelector('[data-nco-pdp]');
    var target = pdp && (pdp.querySelector('[data-variant-picker]') || pdp.querySelector('[data-nco-form]'));
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  // ---------- recipe links open their recipe ----------
  function openRecipe(hash) {
    if (!hash || hash.length < 2) return;
    var target = document.getElementById(decodeURIComponent(hash.slice(1)));
    if (!target) return;
    var d = target.matches('details') ? target : target.querySelector('details');
    if (d) d.open = true;
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href^="#recipe-"]');
    if (a) openRecipe(a.getAttribute('href'));
  });
  window.addEventListener('hashchange', function () { openRecipe(window.location.hash); });

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-nco-pdp]').forEach(initProduct);
    (scope || document).querySelectorAll('[data-nco-scroller]').forEach(initScroller);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); openRecipe(window.location.hash); });
  else { initAll(); openRecipe(window.location.hash); }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
